import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.jsx';

export default function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const onSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            const user = await login(email, password);
            if (user.must_change_password) {
                navigate('/change-password', { replace: true });
                return;
            }
            const from = location.state?.from?.pathname || '/';
            navigate(from, { replace: true });
        } catch (err) {
            if (err.code === 'ACCOUNT_LOCKED') {
                setError('Account is locked due to repeated failed logins. Contact your admin.');
            } else if (err.code === 'ACCOUNT_DISABLED') {
                setError('This account has been disabled.');
            } else {
                setError('Email or password is incorrect.');
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col">
            <div className="flex-1 flex items-center justify-center px-4">
                <div className="w-full max-w-sm">
                    {/* Branding */}
                    <div className="text-center" style={{ marginBottom: 28 }}>
                        <div
                            className="inline-flex items-center justify-center"
                            style={{
                                width: 48,
                                height: 48,
                                borderRadius: 12,
                                background: 'var(--color-status-complete)',
                                color: '#fff',
                                fontSize: 18,
                                fontWeight: 600,
                                letterSpacing: '0.02em',
                                marginBottom: 14,
                            }}
                        >
                            S
                        </div>
                        <h1 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Stars APT</h1>
                        <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginTop: 4 }}>
                            Sign in to continue
                        </p>
                    </div>

                    {/* Card */}
                    <div className="surface-card" style={{ padding: 24 }}>
                        <form onSubmit={onSubmit} className="flex flex-col" style={{ gap: 14 }}>
                            <div>
                                <label
                                    htmlFor="email"
                                    style={{
                                        display: 'block',
                                        fontSize: 12,
                                        fontWeight: 500,
                                        color: 'var(--color-text-secondary)',
                                        marginBottom: 6,
                                    }}
                                >
                                    Email
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    autoComplete="username"
                                    className="input"
                                    autoFocus
                                />
                            </div>
                            <div>
                                <label
                                    htmlFor="password"
                                    style={{
                                        display: 'block',
                                        fontSize: 12,
                                        fontWeight: 500,
                                        color: 'var(--color-text-secondary)',
                                        marginBottom: 6,
                                    }}
                                >
                                    Password
                                </label>
                                <input
                                    id="password"
                                    type="password"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoComplete="current-password"
                                    className="input"
                                />
                            </div>

                            {error && (
                                <div
                                    style={{
                                        background: 'var(--color-pill-rejected-bg)',
                                        border: '0.5px solid var(--color-danger-border)',
                                        color: 'var(--color-danger)',
                                        borderRadius: 'var(--border-radius-md)',
                                        padding: '8px 12px',
                                        fontSize: 13,
                                    }}
                                >
                                    {error}
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={submitting}
                                className="btn btn-primary"
                                style={{ width: '100%', padding: 10 }}
                            >
                                {submitting ? 'Signing in…' : 'Sign in'}
                            </button>
                        </form>
                    </div>

                    <p
                        style={{
                            fontSize: 12,
                            color: 'var(--color-text-tertiary)',
                            marginTop: 14,
                            textAlign: 'center',
                        }}
                    >
                        Forgot your password? Contact your admin to reset it.
                    </p>
                </div>
            </div>

            {/* Footer with the full name */}
            <footer
                style={{
                    textAlign: 'center',
                    fontSize: 11,
                    color: 'var(--color-text-tertiary)',
                    padding: '20px 16px',
                    borderTop: '0.5px solid var(--color-border-tertiary)',
                }}
            >
                Stars Attendance &amp; Productivity Tracking
            </footer>
        </div>
    );
}
